import React from 'react';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import { default as modalTypes } from './types';
import './Modal.scss';

const MODAL_TYPES = {
  'alert': modalTypes.alertModal,
  'confirm': modalTypes.confirmModal,
  'delete': modalTypes.deleteModal,
  'drawer': modalTypes.drawerModal,
  'edit': modalTypes.editModal,
  'empty': modalTypes.emptyModal
}

// Tipos que gestionan su propio portal/backdrop y no deben envolverse en ReactModal.
const SELF_PORTALED_MODAL_TYPES = new Set(['drawer'])

const MODAL_OVER_DRAWER_BODY_CLASS = 'modal-over-drawer'

const syncModalOverDrawerClass = (isReactModalOpen) => {
  if (typeof document === 'undefined') return
  const overDrawer =
    isReactModalOpen && !!document.querySelector('.drawer-backdrop')
  document.body.classList.toggle(MODAL_OVER_DRAWER_BODY_CLASS, overDrawer)
}

// Los portales de React propagan eventos por el árbol de componentes (no por el DOM).
const stopEventBubble = (e) => {
  e.stopPropagation();
};


class Modal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: props.modalProps.open,
      title: props.modalProps.title || "",
    }
    this.closeModal = this.closeModal.bind(this);
    this.updateTitle = this.updateTitle.bind(this);
  }

  // TODO refactor ¿?
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.modalProps.open !== this.props.modalProps.open) {
      this.setState({
        modalIsOpen: nextProps.modalProps.open,
        title: nextProps.modalProps.title || "",
      })
    }
  }

  componentDidMount() {
    this.syncModalOverDrawer()
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.modalIsOpen !== this.state.modalIsOpen ||
      prevProps.modalType !== this.props.modalType
    ) {
      this.syncModalOverDrawer()
    }
  }

  componentWillUnmount() {
    document.body.classList.remove(MODAL_OVER_DRAWER_BODY_CLASS)
  }

  syncModalOverDrawer() {
    const isReactModalOpen =
      this.state.modalIsOpen &&
      this.props.modalType &&
      !SELF_PORTALED_MODAL_TYPES.has(this.props.modalType)
    syncModalOverDrawerClass(isReactModalOpen)
  }

  closeModal() {
    this.props.hideModal()
  }

  updateTitle(newTitle) {
    this.setState({ title: newTitle });
  }

  render() {
    if (!this.props.modalType) {
      return null
    }
    const SpecifiedModal = MODAL_TYPES[this.props.modalType]

    if (SELF_PORTALED_MODAL_TYPES.has(this.props.modalType)) {
      if (!this.state.modalIsOpen) return null
      return (
        <SpecifiedModal
          closeModal={this.closeModal}
          updateTitle={this.updateTitle}
          title={this.state.title}
          {...this.props.modalProps}
        />
      )
    }

    return (
      <>
        <ReactModal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          ariaHideApp={false}
          overlayClassName="modal fade show"
          bodyOpenClassName="modal-open"
          className="modal-dialog modal-dialog-centered"
          shouldCloseOnOverlayClick={false}
          overlayElement={(props, content) => (
            <div
              {...props}
              onClick={(e) => {
                stopEventBubble(e);
                if (typeof props.onClick === "function") props.onClick(e);
              }}
              onMouseDown={(e) => {
                stopEventBubble(e);
                if (typeof props.onMouseDown === "function") props.onMouseDown(e);
              }}
              onPointerDown={stopEventBubble}
            >
              {content}
            </div>
          )}
        >
          <SpecifiedModal
            closeModal={this.closeModal}
            updateTitle={this.updateTitle} // Pasamos el método para actualizar el título
            title={this.state.title} // Título dinámico
            {...this.props.modalProps} />
        </ReactModal>
      </>
    )
  }
}

const mapStateToProps = state => ({
  ...state.modalReducer
})


export default connect(mapStateToProps, null)(Modal);